import { render, staticRenderFns } from "./PolicyView.vue?vue&type=template&id=9f355538&scoped=true&"
import script from "./PolicyView.vue?vue&type=script&lang=js&"
export * from "./PolicyView.vue?vue&type=script&lang=js&"
import style0 from "./PolicyView.vue?vue&type=style&index=0&id=9f355538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f355538",
  null
  
)

export default component.exports